module.exports = __webpack_public_path__ + "a2744374a05d5862437f77be2c970d4d.MP3";